<template>
  <div class="modal-close">
    <span v-if="isActive && show" @click="close" class="modal-close__icon">
      <!-- <svg width="35px" height="35px">
        <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
      </svg>-->
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.9703 5.70725C17.3612 5.31725 17.3612 4.68325 16.9703 4.29325C16.5802 3.90225 15.9472 3.90225 15.5562 4.29325L10.6322 9.21725L5.70725 4.29325C5.31725 3.90225 4.68325 3.90225 4.29325 4.29325C3.90225 4.68325 3.90225 5.31725 4.29325 5.70725L9.21725 10.6322L4.29325 15.5562C3.90225 15.9472 3.90225 16.5802 4.29325 16.9703C4.68325 17.3612 5.31725 17.3612 5.70725 16.9703L10.6322 12.0463L15.5562 16.9703C15.9472 17.3612 16.5802 17.3612 16.9703 16.9703C17.3612 16.5802 17.3612 15.9472 16.9703 15.5562L12.0463 10.6322L16.9703 5.70725Z"
          fill="var(--menu-text-color)"
        />
      </svg>
    </span>
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'modal-close',
    props: {
        isActive: {
            required: true,
            type: Boolean,
        },
        show: {
            required: true,
            type: Boolean,
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style lang="scss">
.modal-close {
  position: relative;
  background-color: var(--bg-color);

  &_padding {
    padding: 36px;
  }

  &__icon {
    display: flex;
    flex-direction: column;
    width: 36px;
    height: 36px;
    cursor: pointer;
    z-index: 2;
    margin-left: auto;
    background-color: var(--bg-color);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: absolute;
    right: 34px;
    top: 34px;

    transition: all 0.3s ease-in;

    &:hover {
      background-color: var(--bg-color3);
    }
  }
}

.order-modal-images {
  .modal-close__icon {
    right: -10px;
    top: -10px;
  }
}
</style>
